export enum PrepareAction {
  ADD = "EXERCISE_ADDED",
  DELETE = "EXERCISE_DELETED",
  HELP_ON = "EXERCISE_HELP_TURNED_ON",
  HELP_OFF = "EXERCISE_HELP_TURNED_OFF",
  QUIZ_SOLUTIONS_ON = "EXERCISE_QUIZ_SOLUTIONS_TURNED_ON",
  QUIZ_SOLUTIONS_OFF = "EXERCISE_QUIZ_SOLUTIONS_TURNED_OFF",
  EXERCISE_REVIEWED = "EXERCISE_REVIEWED",
  EXERCISE_SHORT_ANSWER_REVIEWED = "EXERCISE_SHORT_ANSWER_REVIEWED",
}
